export const Bio = {
  name: "Sagar Arya",
  roles: [
    "Full Stack Developer",
    "Tech Innovator",
    "Software Engineer",
    "Problem Solver",
  ],
  description:
    "I'm a software engineer who believes that powerful technology should solve human problems. My journey is fueled by a curiosity for how things work—from the intricacies of backend system design to the potential of AI. This drive has led me to build a diverse portfolio of projects, including video platforms and EdTech tools, all with a common goal: to create solutions that are not just functional, but meaningful. I'm always learning, always building, and always eager to take on the next big challenge.",
  github: "https://github.com/sagar10arya",
  resume:
    "https://drive.google.com/file/d/1LNIvLblTb60VN79OH9M6WWQPSrLzCRcT/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/sagar-arya-94398b192/",
  twitter: "https://twitter.com/sagar10___",
  insta: "https://www.instagram.com/sagar10___/",
  facebook: "https://www.facebook.com/",
};

export const skills = [
  {
    title: "Programming Languages",
    skills: [
      {
        name: "C",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/C_Programming_Language.svg/570px-C_Programming_Language.svg.png?20201031132917",
      },
      {
        name: "C++",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/180px-ISO_C%2B%2B_Logo.svg.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "SQL",
        image:
          "https://w7.pngwing.com/pngs/552/345/png-transparent-sql-database-computer-icons-sql-icon-blue-text-rectangle-thumbnail.png",
      },
      {
        name: "Javascript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
      },
    ],
  },
  {
    title: "Machine Learning / AI",
    skills: [
      {
        name: "Python",
        image: "https://www.python.org/static/community_logos/python-logo.png",
      },
      {
        name: "NumPy",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/31/NumPy_logo_2020.svg",
      },
      {
        name: "Pandas",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/e/ed/Pandas_logo.svg",
      },
      {
        name: "Matplotlib",
        image: "https://matplotlib.org/_static/logo2.svg",
      },
      {
        name: "Scikit-Learn",
        image:
          "https://scikit-learn.org/stable/_static/scikit-learn-logo-small.png",
      },
      {
        name: "TensorFlow",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg",
      },
      {
        name: "PyTorch",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/96/Pytorch_logo.png",
      },
      {
        name: "Jupyter Notebook",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/38/Jupyter_logo.svg",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image:
          "https://raw.githubusercontent.com/remojansen/logo.ts/master/ts.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node.js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express.js",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png",
      },
      {
        name: "RESTful APIs",
        image:
          "https://img.icons8.com/external-flat-juicy-fish/60/external-api-coding-and-development-flat-flat-juicy-fish.png",
      },
      {
        name: "JWT",
        image: "https://jwt.io/img/pic_logo.svg",
      },
      {
        name: "bcrypt",
        image: "https://avatars.githubusercontent.com/u/9950313?s=200&v=4",
      },
      {
        name: "Redis",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/redis/redis-original-wordmark.svg",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Postman",
        image: "https://voyager.postman.com/logo/postman-logo-icon-orange.svg",
      },
      {
        name: "Appwrite",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAVFBMVEX/////3uf+kK/9cpn9V4b9PXP9SHv9aZP+g6X+s8j//P3/8vb+fKD9Nm7/x9b+mLX9RHj9QHX/5e3+orz/1uH/9fj+i6v+mrb+sMb/7vP9bpf/4uo4sRUwAAAAmklEQVR4AXSQAxYEMRBEa2wzyf3PuYj5H9qEIMuLsqqbtuthM4yTop5hyOrJYjH+9W+HkUHlazpwWmk2+ShTtuHv34VR7AD6rjLNDq6OEJw8sv6Xbrh2IYCvdGuzfySY/rzQqB3TAa7k2k8miRhe6+GHDnBNT882HZC1lMHnngTt46Cf6APg3BIBnGsiAHJXYUBwvU088B0JAADKqxL9JtM8nQAAAABJRU5ErkJggg==",
      },
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Linux",
        image: "https://upload.wikimedia.org/wikipedia/commons/a/af/Tux.png",
      },
      {
        name: "Windows",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAABnRSTlMAAAAAAABupgeRAAAAWklEQVR4AWP4FKBEJPrip8wABrV7GOp3EYtGhgWjFoxaMGrBqAXf/OSIRD995CEWVO9hqN1FLBoOYNlnotF3iI7/O4lHQOVL3hONPo9agB2NWjBqwagFoxYAAB2zMZ7bQW2tAAAAAElFTkSuQmCC",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://commons.wikimedia.org/wiki/Special:FilePath/TATA_Consultancy_Services_Logo_blue.svg",
    role: "Associate System Engineer",
    company: "Tata Consultancy Services",
    date: "April 2025 – Present",
    desc: "Working on a high-definition mapping platform, performing operations on large-scale geospatial datasets used in navigation systems. Collaborate with cross-functional teams to enhance internal data workflows, optimize processing time, and improve system reliability",
    skills: ["Python", "SQL"],
    doc: "",
  },
  {
    id: 1,
    img: "https://cdn-icons-png.flaticon.com/512/906/906334.png",
    role: "Freelance Full-Stack Developer",
    company: "Custom EdTech Platform (Remote)",
    date: "August 2024 – Present",
    desc: "Built and deployed a full-stack EdTech platform to manage personalized student learning for a coaching center, handling the entire SDLC independently.",
    skills: [
      "React.js",
      "Redux Toolkit",
      "React Router",
      "Node.js",
      "Express.js",
      "MongoDB",
      "JWT",
      "bcrypt",
    ],
    doc: "https://conceptualclassess.com",
    // doc: "",
  },
  {
    id: 2,
    img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAATlBMVEX////1+f58sPtOlPmAsvpzq/sXc/gGafhup/ry9/7Q4v0LbPhQlvlBjPnA2fwmfPgbdfgQb/inyvyYwfzj7v5gn/pDjvk0hflKkvmIt/tmn/cMAAAAXElEQVR4Ae2OMRZAMBAFEysZAAjk/hf1ol4FpZdpfjFTfPOVjH1WhZTWeXxV675pkY5Er+mh8CDj1M/AogQrgDhrwgSbEtT7AZIeOjiNxgCStvx3EGJc7jBt5i0XXhkEtjflcGYAAAAASUVORK5CYII=",
    role: "Software Engineering Intern",
    company: "OneVarsity",
    date: "August 2022 - November 2022",
    desc: "Designed and developed the frontend of the company’s website, ensuring a modern and intuitive user experience.",
    skills: ["JavaScript", "HTML", "CSS", "Google Cloud Platform"],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "data:image/jpeg;base64,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",
    school: "Jawaharlal Nehru University, New Delhi",
    date: "Aug 2019 - May 2024",
    grade: "7.7 CGPA",
    degree:
      " Integrated Bachelor of Technology - BTech, Computer Science and Engineering + Master of Science - Management",
    desc: " Courses : Data Structures and Algorithms, Object Oriented Programming, Database Management System, Operating System, Computer Networks, Machine Learning, Artificial Intelligence, Bussiness Analytics, Finance Management, Economics etc.",
  },
];

export const projects = [
  {
    id: 0,
    title: "CryptoVerse",
    date: "Aug 2023 - Sep 2023",
    description:
      "React application that contains everything about cryptocurrencies, crypto markets and exchanges, latest news and much more.",
    image: require("../images/cryptoverse.png"),
    tags: ["React Js", "Redux", "Rapid API", "Ant-Design", "Chart.js"],
    category: "web app",
    github: "https://github.com/sagar10arya/Crypto-World",
    webapp: "https://cyptoworld-47ef34.netlify.app/",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/v2/D5603AQFaiPoR2IF1hg/profile-displayphoto-shrink_400_400/B56ZRRL4faGoAg-/0/1736528861604?e=1758758400&v=beta&t=L8WzfDeOYtaYEoRfQARXx0A-TTO7uqGHMJZdSegwnoY",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
    ],
  },
  {
    id: 1,
    title: "Intrusion Detection System",
    date: "Aug 2022 - Dec 2022",
    description:
      "Intrusion detection systems (IDS) are an important component of modern cybersecurity, helping to protect computer networks and systems from unauthorized access and attacks. Machine learning (ML) techniques  have shown great promise in improving the accuracy and effectiveness of IDS, by enabling automated detection and classification of different types of network traffic and user behavior.",
    image: require("../images/intrusion.jpg"),
    tags: ["Python", "Machine Learning"],
    category: "machine learning",
    github: "https://github.com/sagar10arya",
    webapp: "",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/v2/D5603AQFaiPoR2IF1hg/profile-displayphoto-shrink_400_400/B56ZRRL4faGoAg-/0/1736528861604?e=1758758400&v=beta&t=L8WzfDeOYtaYEoRfQARXx0A-TTO7uqGHMJZdSegwnoY",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
      {
        name: "Shivam Yadav",
        img: "https://media.licdn.com/dms/image/v2/D5603AQHIWsc87ahv6A/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1723100667991?e=1758758400&v=beta&t=VtlehepwsrMdV7qclqYfgzZ5hkf2TA__ATtxQjuYSsU",
        linkedin: "https://www.linkedin.com/in/shivam-yadav-a35603275/",
        // github: "https://github.com/upasana0710",
      },
    ],
  },
  {
    id: 2,
    title: "Compiler Optimisation Using Machine Learning",
    date: "Jan 2023 - Mar 2023",
    description:
      "Researched Compiler Optimization using Machine Learning methodologies, Explored techniques for collecting and preprocessing relevant data, Studied the process of training machine learning models tailored for compiler optimization, Investigated methods for testing and evaluating the performance of optimized compilers.",
    image:
      "https://media.geeksforgeeks.org/wp-content/uploads/20200524115722/Capture3311.png",
    tags: ["Research Project"],
    category: "machine learning",
    github: "https://github.com/sagar10arya",
    webapp: "",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/v2/D5603AQFaiPoR2IF1hg/profile-displayphoto-shrink_400_400/B56ZRRL4faGoAg-/0/1736528861604?e=1758758400&v=beta&t=L8WzfDeOYtaYEoRfQARXx0A-TTO7uqGHMJZdSegwnoY",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
      {
        name: "Shivam Yadav",
        img: "https://media.licdn.com/dms/image/v2/D5603AQHIWsc87ahv6A/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1723100667991?e=1758758400&v=beta&t=VtlehepwsrMdV7qclqYfgzZ5hkf2TA__ATtxQjuYSsU",
        linkedin: "https://www.linkedin.com/in/shivam-yadav-a35603275/",
        // github: "https://github.com/upasana0710",
      },
    ],
  },
  {
    id: 3,
    title: "Full Stack Web App",
    date: "March 2023 - April 2023",
    description:
      "Build a full stack web app having stunning UI with native mobile feel, special tech stack and infinite scroll feature and amazing performance. Learned and used Appwrite to handle backend must faster and much lower cost. Implemented robust and stunning authentication, pages for exploring posts, ability to like and save posts through a seperated dedicated page integrated together with search functionality.",
    image: require("../images/full-stack.png"),
    tags: ["ReactJS", "CSS", "Appwrite"],
    category: "web app",
    github: "https://github.com/sagar10arya/full-stack-web-app",
    webapp: "",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/v2/D5603AQFaiPoR2IF1hg/profile-displayphoto-shrink_400_400/B56ZRRL4faGoAg-/0/1736528861604?e=1758758400&v=beta&t=L8WzfDeOYtaYEoRfQARXx0A-TTO7uqGHMJZdSegwnoY",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
    ],
  },

  {
    id: 4,
    title: "Weather Forecast Web App",
    date: "January 2024",
    description:
      "Developed a web app to provide real-time weather forecasts. Implemented search functionality to fetch weather data from weather API and display current conditions for cities worldwide.",
    image: require("../images/weather.png"),
    tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github:
      "https://github.com/sagar10arya/Weather-Forecast?tab=readme-ov-file",
    webapp: "https://yours-weather-forecast.netlify.app/",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/v2/D5603AQFaiPoR2IF1hg/profile-displayphoto-shrink_400_400/B56ZRRL4faGoAg-/0/1736528861604?e=1758758400&v=beta&t=L8WzfDeOYtaYEoRfQARXx0A-TTO7uqGHMJZdSegwnoY",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
    ],
  },

  {
    id: 5,
    title: "Chess Game",
    date: "August-November 2022",
    description: "For real-time chess game with interactive UI",
    image:
      "https://media.istockphoto.com/id/2163761303/photo/cropped-hand-of-man-holding-chess-piece.jpg?b=1&s=612x612&w=0&k=20&c=73snYvci6uygEwyFQwlul1AVeR4btIDvHuh_eMBDlF8=",
    tags: ["C++"],
    category: "games",
    github: "https://github.com/sagar10arya/Chess-Project",
    // webapp: "https://playing-rock-paper-scissors.netlify.app/",
    member: [
      {
        name: "Sagar Arya",
        img: "https://media.licdn.com/dms/image/v2/D5603AQFaiPoR2IF1hg/profile-displayphoto-shrink_400_400/B56ZRRL4faGoAg-/0/1736528861604?e=1758758400&v=beta&t=L8WzfDeOYtaYEoRfQARXx0A-TTO7uqGHMJZdSegwnoY",
        linkedin: "www.linkedin.com/in/sagar10arya",
        github: "https://github.com/sagar10arya",
      },
    ],
  },

  // {
  //   id: 6,
  //   title: "Rock Paper Scissor Game",
  //   date: "January 2021",
  //   description:
  //     "For real-time interactive engagement between gamer and the computer. Provides near-instantaneous replies.",
  //   image: require("../images/rockPpaerScissor.png"),
  //   tags: ["HTML", "CSS", "Javascript"],
  //   category: "games",
  //   github: "https://github.com/sagar10arya/Games/tree/main/RockPaperScissor",
  //   webapp: "https://playing-rock-paper-scissors.netlify.app/",
  //   member: [
  //     {
  //       name: "Sagar Arya",
  //       img: "https://media.licdn.com/dms/image/v2/D5603AQFaiPoR2IF1hg/profile-displayphoto-shrink_400_400/B56ZRRL4faGoAg-/0/1736528861604?e=1758758400&v=beta&t=L8WzfDeOYtaYEoRfQARXx0A-TTO7uqGHMJZdSegwnoY",
  //       linkedin: "www.linkedin.com/in/sagar10arya",
  //       github: "https://github.com/sagar10arya",
  //     },
  //   ],
  // },
];
